
import { useRestartApplicationMutation } from 'rental/generated.graphql';


interface Props {
  className?: string;
  portalSlug: string;
}

export const RestartApplicationButton = (props: Props) => {
  const [result, execute] = useRestartApplicationMutation();
  return (
    <>
      <button 
        type="button"
        className={props.className} 
        disabled={result.fetching}
        onClick={async ()=> {
          await execute({input: {portalSlug: props.portalSlug}});
        }}
      >
        Restart Application
      </button>
    </>
  );
}